import React from 'react';
import { AppShell } from './AppShell';

export const PublicLayout: React.FC = () => <AppShell variant="public" />;
export const CustomerLayout: React.FC = () => <AppShell variant="customer" />;
export const AdminLayout: React.FC = () => <AppShell variant="admin" />;
